import type { ReactNode } from 'react';
import { useTranslation } from 'react-i18next';
import { DEFAULT_INK_COLOR, type BondDrawingConfig } from '@peruselab/structure-editor/domain/bonds';

interface BondSettingsPanelProps {
  readonly colorPalette?: ReactNode;
  readonly bondConfig: BondDrawingConfig;
  readonly onColorChange: (color: string) => void;
  readonly onNumericChange: (key: keyof BondDrawingConfig, value: string, minimum: number) => void;
}

export function BondSettingsPanel({
  bondConfig,
  onColorChange,
  onNumericChange,
  colorPalette
}: BondSettingsPanelProps) {
  const { t } = useTranslation();
  return (
    <details className="bond-settings">
      <summary>{t('bondSettingsPanel.summary')}</summary>
      <div className="bond-settings-grid">
        <div className="bond-settings-color">
          <label>
            <span>{t('bondSettingsPanel.bondColor')}</span>
            {/* A native color input needs the concrete default ink when no color was chosen. */}
            <input
              type="color"
              value={bondConfig.color ?? DEFAULT_INK_COLOR}
              onChange={(event) => onColorChange(event.target.value)}
            />
          </label>
          {colorPalette}
        </div>
        <label>
          <span>{t('bondSettingsPanel.standardLength')}</span>
          <input
            type="number"
            min="1"
            value={bondConfig.lengthPx}
            onChange={(event) => onNumericChange('lengthPx', event.target.value, 1)}
          />
        </label>
        <label>
          <span>{t('bondSettingsPanel.angleInterval')}</span>
          <input
            type="number"
            min="1"
            max="180"
            value={bondConfig.angleIntervalDegrees}
            onChange={(event) => onNumericChange('angleIntervalDegrees', event.target.value, 1)}
          />
        </label>
        <label>
          <span>{t('bondSettingsPanel.proposalRadius')}</span>
          <input
            type="number"
            min="1"
            value={bondConfig.proposalRadiusPx}
            onChange={(event) => onNumericChange('proposalRadiusPx', event.target.value, 1)}
          />
        </label>
      </div>
    </details>
  );
}
